import { IStepOrderTableReport } from "../../../../Interfaces/stepInterfaces";
import { getCompetitionSubOrderChances } from "../../../../Requests/stepRequests";
import { CommonTableUI } from "../../../TableTemplate/common";
import TableTemplate from "../../../TableTemplate/tableTemplate";

interface IProps {
  orderId: number;
}

const CompetitionSubOrderChancesTable = ({ orderId }: IProps) => {
  return (
    <TableTemplate<{ orderId: number }, IStepOrderTableReport>
      getDataTable={getCompetitionSubOrderChances}
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      initialSearchParameters={{ orderId }}
    />
  );
};

export default CompetitionSubOrderChancesTable;
